module.exports = __webpack_public_path__ + "static/media/quote-roosevelt-right-thing.290c3a40.jpg";